<template>
  <div class="new_exercise-milestone">
    <div class="list-wrapper" ref="srollView">
      <div class="item" :class="{
        'unlock' : item.status != 'LOCKED',
        'choosed': item.exercisedDate === currentPlanDate
        }" v-for="item in list" :key="item.planId" :date="item.exercisedDate">
        <div class="circle" @click.stop="mileStoneItemAction(item)">
          <div class="row-item">
            <div class="day-num">
              {{ item.offset }}
            </div>
          </div>
        </div>
        <!-- <p class="title">{{item.offsetName}}</p> -->
        <p class="progress" v-show="item.percent >= 0 && item.status != 'LOCKED' && item.hasRequiredTask">已学{{item.percent}}%</p>
      </div>
      <div class="line" :style="{
        'width': (98 * list.length - 40) / 100 + 'rem',
        'background': `linear-gradient(to right, #FF6600 ${(currentDayCount * 100 - 100) / (totalDayCount - 1 || 1) }%, #EFEFEF 0%)`
      }"></div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue';
export default defineComponent({
  props: {
    list: {
      type: Array,
      default: () => {
        return []
      }
    },
    currentDayCount: {
      type: Number,
      default: 0
    },
    totalDayCount: {
      type: Number,
      default: 2
    },
    currentPlanDate: {
      type: String,
      default: ''
    }
  },
  watch: {
    currentPlanDate() {
      this.$nextTick(() => {
        let dom = this.$refs.srollView
        const [node] = Array.from(dom.childNodes).filter(n =>
          n.classList && n.classList.contains('choosed')
        )
        if (node) {
          if (node.offsetLeft + node.offsetWidth < dom.offsetWidth) {
            dom.scrollTo(0, 0)
          } else if (node.offsetLeft + node.offsetWidth >= dom.offsetWidth) {
            dom.scrollTo(node.offsetLeft + node.offsetWidth, 0)
          }
        }
      })
    }
  },
  methods: {
    mileStoneItemAction(item) {
      this.$store.commit('SET_CHOOSEDATE', item.exercisedDate)
      this.$emit('change', item)
    }
  }
})

</script>

<style lang="scss" scoped>
.new_exercise-milestone {
  overflow: hidden;
  margin-bottom: 40px;
  .list-wrapper {
    display: flex;
    -webkit-overflow-scrolling: touch;
    overflow-scrolling: touch;
    overflow-y: auto;
    position: relative;
    &::-webkit-scrollbar {
      display: none;
    }
    .item {
      flex-shrink: 0;
      width: 98px;
      display: flex;
      flex-direction: column;
      align-items: center;
      font-size: 20px;
      position: relative;
      z-index: 5;
      color: #B1B1B3;
      overflow: hidden;
      .title {
        height: 34px;
        width: 100%;
        line-height: 34px;
        font-size: 24px;
        margin-top: 14px;
      }
      .title , .progress {
        height: 28px;
        overflow: hidden;
        word-break: break-all;
        text-overflow: ellipsis;
        white-space: nowrap;
        color: inherit;
        text-align: center;
      }
      .progress {
        font-size: 20px;
        padding-top: 5px;
      }
    }
  }
}
.row-item {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  overflow: hidden;
  background: #fff;
  .day-num {
    width: 60px;
    height: 60px;
    border-radius: 50%;
    text-align: center;
    line-height: 56px;
    border: 2Px solid #EFEFEF;
    background: #EFEFEF;
    box-sizing: border-box;
  }
}
.unlock {
  color: rgba(255, 102, 0, 0.6);
  .day-num {
    color: #fff;
    background: rgba(255, 102, 0, 0.6);
    border-color:#FECBA4;
  }
}
.choosed {
  color: #FF6600 !important;
  .day-num {
    color: #fff;
    background: #FF6600;
    border-color:#FECBA4;
  }
}
.line {
  height: 2PX;
  left: 20px;
  top: 30px;
  position: absolute;
}
</style>
